<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:15px; margin-bottom:-10px;">
      <h4><span style="padding-right:10px"></span> <i class="fa fa-edit"></i>Status: <b>{{lblHeading}}</b></h4>
    </div>
  </div>
  <hr />
  <div class="row" style="margin-top:20px;margin-left:0px;margin-right:0px;padding:0px;">
    <div class="col-md-12" style="margin:0px;padding:0px;">
      <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
        <table style="margin:0px;padding:0px;width:100%">
          <tr style="margin:0px;padding:0px;">
            <td style="margin:0px;padding:0px;width:50%;vertical-align:top;">
              <!--<div class="col-12" style="margin:5px auto;padding:0px;">-->
                <div class="row" style="margin:5px auto;padding:0px;">
                  <!--<div class="col-12">-->
                  <div class="col-md-6 no-sp" >
                    <label class="col-sm-12 control-label">
                      <strong>ID<a class="red-asterik"> *</a></strong>
                      <span *ngIf="isIdDup" class="text-danger">Status ID already in use</span>
                    </label>
                    <div class="col-md-12">
                      <input type="number"  name="id" formControlName="id" class="form-control" onkeydown="return event.keyCode !== 69" onKeyPress="if(this.value.length==5)return false;" [ngClass]="{'error':form.controls.id.invalid && form.controls.id.dirty, 'noerror': form.controls.id.valid && form.controls.id.dirty}" title="ids must be unique. Main sort order if group_id and sort_order not used." />
                      <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.id.invalid && form.controls.id.dirty">
                        <p *ngIf="form.controls.id.errors.required">ID is required</p>
                        <p *ngIf="form.controls.id.errors.min">ID must be greater than zero</p>
                        <p *ngIf="form.controls.id.errors.checkInt">Invalid Status ID</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 no-sp" >
                    <label class="col-sm-12 control-label">
                      <strong>Code<a class="red-asterik"> *</a></strong>
                      <span *ngIf="isCodeDup" class="text-danger">Code already in use</span>
                    </label>
                    <div class="col-sm-12">
                      <input type="text" style="height:38px!important;" name="code" formControlName="code" class="form-control" [ngClass]="{'error':form.controls.code.invalid && form.controls.code.dirty, 'noerror': form.controls.code.valid && form.controls.code.dirty}" title="Codes must be unique. Main sort order if group_code and sort_order not used." />
                      <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.code.invalid && form.controls.code.dirty">
                        <p *ngIf="form.controls.code.errors.required">Code is required</p>
                        <p *ngIf="form.controls.code.errors.maxlength">Code must not be more than 12 characters.</p>
                      </div>
                    </div>
                  </div>

                  <!--</div>-->
                <!--</div>-->
              </div>
              <div class="col-12" style="margin:5px auto;padding:0px;">
                <label class="col-sm-12 control-label"><strong>Status From Rule</strong></label>
                <div class="col-sm-12" style="width:100%;">
                  <input style="width:100%;" name="status_from_rule" formControlName="status_from_rule" class="form-control" [ngClass]="{'error':form.controls.status_from_rule.invalid && form.controls.status_from_rule.dirty, 'noerror': form.controls.status_from_rule.valid && form.controls.status_from_rule.dirty}" title="To be determined - can hold a coded rule or list of status codes to create a rule to determine valid status codes from which the the status can be moved to this status code." />
                  <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.status_from_rule.invalid && form.controls.status_from_rule.dirty">
                    <p *ngIf="form.controls.status_from_rule.errors.required">Status From Rule is required</p>
                    <p *ngIf="form.controls.status_from_rule.errors.maxlength">Status From Rule must not be more than 100 characters.</p>
                  </div>
                </div>
              </div>
              <div class="col-12" style="margin:5px auto;padding:0px;">
                <label class="col-sm-12 control-label"><strong>Status From </strong></label>
                <div class="col-sm-12">
                  <input type="number" min="0" onkeydown="return event.keyCode !== 69" name="status_from" formControlName="status_from" class="form-control" [ngClass]="{'error':form.controls.status_from.invalid && form.controls.status_from.dirty, 'noerror': form.controls.status_from.valid && form.controls.status_from.dirty}" title="To be determined - can hold a default status code, or the previous status code." />
                  <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.status_from.invalid && form.controls.status_from.dirty">
                    <p *ngIf="form.controls.status_from.errors.checked">Negative numbers are not allowed</p>
                    <p *ngIf="form.controls.status_from.errors.checkInt">Invalid Status From</p>
                  </div>
                </div>
              </div>

              <div class="col-12" style="margin:5px auto;padding:0px;">
                <label class="control-label col-sm-12">
                  <strong>Status Use Indicator<a class="red-asterik"> *</a>&nbsp;</strong>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" id="invCat" [(ngModel)]="selectedSUI" (change)="onSelectChange()" name="status_use_ind" formControlName="status_use_ind" style="" title="Indicates where it is used on dropdowns or lists.">
                    <option *ngFor="let sui of utility.statusUseIndicators" [ngValue]="sui.key">{{sui.value}}</option>
                  </select>
                </div>
              </div>

            </td>
            <td style="margin:0px; padding:0px;width:50%; vertical-align:top;">

              <div class="row" style="margin:5px auto; padding:0px;">
                <label class="col-sm-12 control-label"><strong>Description</strong></label>
                <div class="col-sm-12">
                  <input style="width:100%;" name="description" formControlName="description" class="form-control" [ngClass]="{'error':form.controls.description.invalid && form.controls.description.dirty, 'noerror': form.controls.description.valid && form.controls.description.dirty}" title="Free text description of the entity occurrence." />
                  <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.description.invalid && form.controls.description.dirty">
                    <p *ngIf="form.controls.description.errors.required">Description is required</p>
                    <p *ngIf="form.controls.description.errors.maxlength">Description must not be more than 100 characters</p>
                  </div>
                </div>
              </div>

              <div class="col-12" style="margin:5px auto;padding:0px;">
                <label class="col-sm-12 control-label"><strong>Status To Rule</strong></label>
                <div class="col-sm-12" style="width:100%;">
                  <input style="width:100%;" name="status_to_rule" formControlName="status_to_rule" class="form-control" [ngClass]="{'error':form.controls.status_to_rule.invalid && form.controls.status_to_rule.dirty, 'noerror': form.controls.status_to_rule.valid && form.controls.status_to_rule.dirty}" title="To be determined - can hold a coded rule or list of status codes to create a rule to determine valid status codes to which the the status can be moved from this status code." />
                  <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.status_to_rule.invalid && form.controls.status_to_rule.dirty">
                    <p *ngIf="form.controls.status_to_rule.errors.required">Status To Rule is required</p>
                    <p *ngIf="form.controls.status_to_rule.errors.maxlength">Status To Rule must not be more than 100 characters.</p>
                  </div>
                </div>
              </div>

              <div class="col-12" style="margin:5px auto;padding:0px;">
                <label class="col-sm-12 control-label"><strong>Status To </strong></label>
                <div class="col-sm-12">
                  <input type="number" min="0" onkeydown="return event.keyCode !== 69" name="status_to" formControlName="status_to" class="form-control" [ngClass]="{'error':form.controls.status_to.invalid && form.controls.status_to.dirty, 'noerror': form.controls.status_to.valid && form.controls.status_to.dirty}" title="To be determined - can hold a default status code to which the entity will change if it progresses." />
                  <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.status_to.invalid && form.controls.status_to.dirty">
                    <p *ngIf="form.controls.status_to.errors.checked">Negative numbers are not allowed</p>
                    <p *ngIf="form.controls.status_to.errors.checkInt">Invalid Status To</p>
                  </div>
                </div>
              </div>             
            </td>
          </tr>

            <tr style="margin:0px;padding:0px;">
            <td style="margin:0px;padding:0px;">
              <div class="col-md-12" style="margin:0px;padding:0px;">
                <div class="row" style="margin-bottom:20px;margin-top:5px;margin-left:0px;">
                  <!--<div class="col-md-6" style="margin-left:0px;padding-left:0px;">
            <label class="control-label col-md-12">
              <strong>Status Use Indicator *&nbsp;</strong>
            </label>
            <div class="col-md-12">
              <select class="form-control" id="invCat" [(ngModel)]="selectedSUI" (change)="onSelectChange()" name="status_use_ind" formControlName="status_use_ind" style="" title="Indicates where it is used on dropdowns or lists.">
                <option *ngFor="let sui of utility.statusUseIndicators" [ngValue]="sui.key">{{sui.value}}</option>
              </select>
            </div>
          </div>-->
                </div>
              </div>
            </td>
            <td style="margin:0px; padding:0px;"></td>
          </tr>
        </table>
        
                  <!-- Sorting and Displaying -->
                  <div class="col-12">
                    <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
                      <legend class="scheduler-border tsk-display blackcontrol">Sorting And Displaying</legend> 
                      <div class="col-md-12 no-sp" style="margin:5px auto;padding:0px;">
                        <div class="row">
                          <div class="col-md-3">
                            <label class="control-label col-md-12 pull-right">
                              <strong class="" style="">Sort Order<a class="red-asterik"> *</a>&nbsp; </strong>
                            </label>
                            <div class="col-md-12">
                              <select id="sort_order" class="form-control" name="sort_order" formControlName="sort_order" style="" title="Allows user to put in a sorting code. By default, all rows will have sort_order 1.">
                                <option *ngFor="let rank of utility.sortOrderList" [ngValue]="rank" [selected]="0">{{rank}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <label class="control-label col-sm-12">
                              <strong>Group Code<a class="red-asterik"> *</a>&nbsp; </strong>
                            </label>
                            <div class="col-sm-12">
                              <input type="text" class="form-control" name="group_code" formControlName="group_code" style="" [ngClass]="{'error':form.controls.group_code.invalid && form.controls.group_code.dirty, 'noerror': form.controls.group_code.valid && form.controls.group_code.dirty}" title="Allows user to group codes. By default, all rows will belong to group A.">
                              <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.group_code.invalid && form.controls.group_code.dirty">
                                <p *ngIf="form.controls.group_code.errors.required">Group Code is required</p>
                                <p *ngIf="form.controls.group_code.errors.maxlength">Group Code must not be more than 12 characters.</p>
                              </div>
                            </div>
        
                          </div>
                          <div class="col-md-3">
                            <label class="control-label col-sm-12">
                              <strong style="">Display When<a class="red-asterik"> *</a>&nbsp; </strong>
                            </label>
                            <div class="col-sm-12">
                              <select class="form-control" id="invCat" [(ngModel)]="selectedDisplay" (change)="onSelectChange()" name="display_ind" formControlName="display_ind" style="" title="Indicates where it is used on dropdowns or lists.">
                                <option *ngFor="let ind of utility.displayIndicators" [ngValue]="ind.key">{{ind.value}}</option>
                              </select>
                            </div>
                          </div>
          
                          <div class="col-md-3">
        
                            <div class="form-check form-check-inline">
                              <br/>
                              <br/>
                              <label><strong style="">Active?&nbsp; </strong></label>
                              <input class="form-control input-sm" type="checkbox" id="is_active" value="is_active" formControlName="is_active" title="An indicator to control if the row will appear on a list or in a search. Can be used to indicate logically deleted.">
                            </div>
                          </div>
                        </div>
                      </div> 
                    </fieldset>
                  </div>
                  <!-- End of Sorting and Displayings -->

        <div class="col-md-12" style="margin-top:10px;padding-top:10px; font-size:11px;">
          <dl style="width:460px;">
            <dt style="width:40px;">Created</dt>
            <dd [innerHTML]="audit.created"></dd>
            <dt style="width:46px;">Updated</dt>
            <dd [innerHTML]="audit.updated"></dd>
          </dl>
        </div>

        <!-- End -->

        <hr>
        <div class="col-md-12">
          <br>
          <button title="Save change(s)" type="submit" id="btnSave" [disabled]="!form.valid" class="btn btn-md btn-success pull-right" style="width:10%; margin-left:10px; "><i class="fa fa-save"></i> Save</button>
          <button title="Go Back" type="button" id="btnCancel" [routerLink]="['/status/list']" class="btn btn-md btn-info pull-right" style="width:10%; margin-left:10px; "><i class="fa fa-arrow-circle-left"></i> Back</button>
        </div>
      </form>
    </div>
  </div>
</div> <!--End Container -->
